import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { resolveApplicable, WindowRef } from '@spartacus/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CustomHttpErrorHandler } from './custom-http.handler';

@Injectable({
  providedIn: 'root',
})
export class CustomHttpErrorInterceptor implements HttpInterceptor {

  private sessionStorage: Storage;

  constructor(
    @Inject(CustomHttpErrorHandler) protected handlers: CustomHttpErrorHandler[],
    winRef: WindowRef
  ) {
      this.sessionStorage = winRef.sessionStorage;
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const shopView = this.sessionStorage.getItem('shopView');
    if (shopView) {
      req = req.clone({
        setParams: {
          shopView,
        },
      });
    }
    return next.handle(req)
      .pipe(
        // Handle errors
        catchError((res: any) => {
          if (res instanceof HttpErrorResponse) {
            this.handleErrorResponse(req, res);
            return throwError(res);
          }
        })
      );
  }

  protected handleErrorResponse(req: HttpRequest<any>, res: HttpErrorResponse): void {
    const handler = this.getResponseHandler(res);
    if (handler) {
      handler.handleError(req, res);
    }
  }

  /**
   * return the error handler that matches the `HttpResponseStatus` code.
   * If no handler is available, the UNKNOWN handler is returned.
   */
  protected getResponseHandler(response: HttpErrorResponse): CustomHttpErrorHandler {
    return resolveApplicable(this.handlers, [response]);
  }
}
